function Header() {
    return (
        <header>
            <div className="header-info">
                Developer? View the code on <a href="https://github.com/dideldumthecat/lala-website-react" target="_blank">GitHub</a>
            </div>
        </header>
    );
}

export default Header;
